import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noConfirmation: {
    description: 'confirmationEnum.noConfirmation',
    defaultMessage: 'No Confirmation',
    id: 'wPFl/2',
  },
  delivery: {
    description: 'confirmationEnum.delivery',
    defaultMessage: 'Delivery',
    id: '3yPQQb',
  },
  signature: {
    description: 'confirmationEnum.signature',
    defaultMessage: 'Signature',
    id: 'C8IoDh',
  },
  adultSignature: {
    description: 'confirmationEnum.adultSignature',
    defaultMessage: 'Adult Signature',
    id: 'e8nt7i',
  },
  ageVerification16Plus: {
    description:
      'A delivery confirmation requirement ensuring the package is only handed over to a person verified to be at least 16 years old.',
    defaultMessage: 'Age Verification 16+',
    id: 'KuFEMq',
  },
  directSignatureOrVerbal: {
    description: 'confirmationEnum.directSignature',
    defaultMessage: 'Verbal (UPS) / Direct Signature (FedEx)',
    id: 'VmDKm6',
  },
  deliveryCode: {
    description: 'confirmationEnum.deliveryCode',
    defaultMessage: 'Delivery Code',
    id: 'egYF+d',
  },
  canadaPostDoNotSafeDrop: {
    description: 'Confirmations.options.canadaPostDoNotSafeDrop',
    defaultMessage: 'Do Not Safe Drop (Canada Post Only)',
    id: 'AQmpIu',
  },
  canadaPostLeaveAtDoor: {
    description: 'Confirmations.options.canadaPostLeaveAtDoor',
    defaultMessage: 'Leave at Door - Do Not Card (Canada Post Only)',
    id: '64esb8',
  },
});

const anzMessages = defineMessages({
  noConfirmation: {
    defaultMessage: 'Authority to Leave',
    description: 'A message to select as a dropdown item for an Australian user.',
    id: 'A8Qn3p',
  },
  delivery: {
    description: 'A message to select as a dropdown item for an Australian user.',
    defaultMessage: 'No Authority to Leave',
    id: 'LH9cBa',
  },
  signature: {
    description: 'A message to select as a dropdown item for an Australian user.',
    defaultMessage: 'Safe Drop',
    id: 'M/7o3M',
  },
  adultSignature: {
    description: 'A message to select as a dropdown item for an Australian user.',
    defaultMessage: 'Service Confirmation',
    id: 'YtwBCe',
  },
  deliveryCode: {
    description: 'Delivery confirmation type where the recipient provides a code upon delivery.',
    defaultMessage: 'Delivery Code',
    id: 'SqRwnf',
  },
  ageVerification16Plus: {
    description:
      'A delivery confirmation requirement ensuring the package is only handed over to a person verified to be at least 16 years old.',
    defaultMessage: 'Age Verification 16+',
    id: 'KuFEMq',
  },
});

export const Confirmations = {
  NoConfirmation: {
    ordinal: 0,
    messageDescriptor: messages.noConfirmation,
  },
  Delivery: {
    messageDescriptor: messages.delivery,
  },
  Signature: {
    messageDescriptor: messages.signature,
  },
  AdultSignature: {
    messageDescriptor: messages.adultSignature,
  },
  DirectSignature: {
    messageDescriptor: messages.directSignatureOrVerbal,
  },
  DeliveryCode: {
    messageDescriptor: messages.deliveryCode,
  },
  AgeVerification16Plus: {
    messageDescriptor: messages.ageVerification16Plus,
  },
};

export const SellerConfirmations = {
  ...Confirmations,
};

export const ANZSellerConfirmations = {
  NoConfirmation: {
    ordinal: 0,
    messageDescriptor: anzMessages.noConfirmation,
  },
  Delivery: {
    messageDescriptor: anzMessages.delivery,
  },
  Signature: {
    messageDescriptor: anzMessages.signature,
  },
  AdultSignature: {
    messageDescriptor: anzMessages.adultSignature,
  },
  DeliveryCode: {
    messageDescriptor: anzMessages.deliveryCode,
  },
  AgeVerification16Plus: {
    messageDescriptor: anzMessages.ageVerification16Plus,
  },
};

export const SellerConfirmationsWithCanadaPost = {
  ...SellerConfirmations,
  CanadaPostDoNotSafeDrop: {
    messageDescriptor: messages.canadaPostDoNotSafeDrop,
  },
  CanadaPostLeaveAtDoor: {
    messageDescriptor: messages.canadaPostLeaveAtDoor,
  },
};
